// react
import { useEffect, useState } from "react";
import { useRouter } from "next/router";
import Image from "next/image";

// redux
import { bindActionCreators } from "redux";
import { connect, useStore, Provider } from "react-redux";
import {
  fetchCollaboration,
  getCategories,
  getFollowedCategories,
  getPromos,
  getPrefs,
  setApplication,
  showAppModal,
} from "~/redux/actions/app";

import {
  fetchPost,
  checkPostFlags,
  deletePost,
  hidePost,
  createPostPin,
  deletePostPin,
  fetchPostSuggests,
  createPostFeature,
  deletePostFeature,
  setVisibility,
} from "~/redux/actions/post";
import { getUserInfo, getUser } from "~/redux/actions/user";
import { fetchPostComments } from "~/redux/actions/comment";
import { fetchRandomTalentPosts, fetchOpenings } from "~/redux/actions/talent";
import { postUrl } from "~/utils/route";

// views
import Link from "next/link";
import Error from "~/pages/_error";
import {
  Alert,
  Badge,
  Button,
  Card,
  Col,
  Dropdown,
  Form,
  Menu,
  Modal,
  Popconfirm,
  Tooltip,
  AutoComplete,
  Radio,
  Space,
} from "antd";
import {
  ShareAltOutlined,
  DownOutlined,
  SettingOutlined,
  MessageOutlined,
  PushpinOutlined,
  HighlightOutlined,
  DeleteOutlined,
  FormOutlined,
  PushpinFilled,
  GlobalOutlined,
  LockOutlined,
  FilterOutlined,
  FrownOutlined,
  RiseOutlined,
  HomeOutlined,
  EyeOutlined,
} from "@ant-design/icons";
import SiteLayout from "~/components/layout/SiteLayout";
import FieldItem from "~/components/app/FieldItem";
import RichContent from "~/components/app/RichContent";
import BadgeText from "~/components/app/BadgeText";
import LastModifiedTag from "~/components/app/LastModifiedTag";
import UserInfoBlock from "~/components/users/UserInfoBlock";
import CommentForm from "~/components/comment/CommentForm";
import CommentList from "~/components/comment/CommentList";
//comment link removed
//import NewCommentLink from '~/components/comment/NewCommentLink'
//add comment sort
import CommentSortMenu from "~/components/comment/CommentSortMenu";
import WechatGroupCard from "~/components/site/WechatGroupCard";
import SharePopover from "~/components/site/SharePopover";
import RelatedPostList from "~/components/post/RelatedPostList";
import PostMarkAction from "~/components/post/PostMarkAction";
import PostVoteAction from "~/components/post/PostVoteAction";
import PostCategoryHint from "~/components/post/PostCategoryHint";
import UserAvatar from "~/components/user/UserAvatar";
import UserLink from "~/components/user/UserLink";
import PostChargeBlock from "~/components/post/PostChargeBlock";
import CategoryLink from "~/components/post/CategoryLink";
import PostContactAddon from "~/components/post/PostContactAddon";
import PostStatusToggleAddon from "~/components/post/PostStatusToggleAddon";
import FeaturedIcon from "~/public/static/icons/featured.svg";
// add report action
import SiteReportAction from "~/components/site/SiteReportAction";
import TimeAgoTag from "~/components/app/TimeAgoTag";
import CategoryCard from "~/components/sider/CategoryCard";
import RelatedGroupsCard from "~/components/sider/RelatedGroupsCard";

// Utils
import { checkOwner } from "~/utils/app";
import { hasAnyRole } from "~/utils/user";
import { appUrl } from "~/settings";
import _ from "lodash";
import { stripHtml } from "../../../utils/seo";
import PostPromos from "../../../components/post/PostPromos";
import PostTalentAddon from "../../../components/post/PostTalentAddon";
import TalentPostList from "~/components/sider/TalentPostList";
import lscache from "lscache";
import TagLink from "~/components/tag/TagLink";
import WordingTemplateAutoComplete from "~/components/app/WordingTemplateAutoComplete";
import BaseModal from "../../../components/modal/BaseModal";
import { showAppMessage } from "../../../redux/actions/app";
import AppMobileNav from "../../../components/app/AppMobileNav";
import { isMobile } from "react-device-detect";
import { timeAgo } from "~/utils/app";

// Consts
const STYLE_MB2 = {
  marginBottom: "2px",
  fontSize: "16px",
};

const Page = (props) => {
  const store = useStore();
  // hooks
  const [state, setState] = useState({
    post: props.post,
    commentList: props.commentList,
    sort: "-hot",
    sortKey: "hot",
    isDesc: true,
  });
  const [isOpen, setIsOpen] = useState(false);
  const [visibility, setVisibility] = useState();
  const [hideReason, setHideReason] = useState("");
  const [hideTemplateId, setHideTemplateId] = useState(null);
  const [opening, setOpening] = useState();

  const router = useRouter();

  const isJob = () => {
    return (
      state.post.category.code === "jd" || state.post.category.code === "talent"
    );
  };

  //此处为了防止手机构造帖子id参数

  if (!state.post && props.responseError) {
    return (
      <Error
        statusCode={props.responseError.statusCode}
        error={props.responseError}
      />
    );
  }

  // props
  const isModified =
    state.post.modified_at &&
    state.post.modified_at !== state.post.published_at;
  const isOwner = checkOwner(state.post, props.user);
  const isAdmin = hasAnyRole(props.user, ["admin", "editor"]);
  const hasPostCharges = props.postChargesCount && props.postChargesCount > 0;

  const showCommentForm =
    !props.collaboration || hasAnyRole(props.user, ["paid_category_follower"]);

  const canEdit = isOwner || isAdmin;
  const supportContactAddon = () => {
    return _.includes(state.post.category.addons, "contact_info");
  };
  const canViewPost =
    (props.flags.limited && !props.flags.limited.includes(props.post.id)) ||
    props.post.paid_type === "free" ||
    canEdit;

  // handles
  const handleDelete = () => {
    props.deletePost(props.token, state.post.id);
  };
  const handlePenaltyDelete = (reason = null, templateId = null) => {
    props.deletePost(props.token, state.post.id, {
      is_delete_ele: true,
      reason,
      reason_template_id: templateId,
    });
  };
  const handleHide = (hide, reason, templateId) => {
    props.hidePost(
      props.token,
      state.post.id,
      hide,
      reason,
      templateId,
      (hide, hidedAt, hideUser) => {
        setState({
          post: {
            ...props.post,
            hide,
            hided_at: hidedAt,
            hide_user: hideUser,
          },
        });
      }
    );
  };

  const handleInit = () => {
    props.getPrefs();
    if (props.token) {
      isAdmin &&
        props.post.transparent &&
        props.showAppMessage("帖子已透明", "info");
      props.getUserInfo(props.token);
      props.checkPostFlags(
        props.token,
        ["marked", "upvoted", "downvoted", "limited"],
        [props.post.id]
      );
      setVisibility(props.post.visibility);
    }

    // props.getPromos();
    setState({ ...state, post: props.post, commentList: props.commentList });
    getUser(props.post.user.id).then((user) => {
      setState({
        ...state,
        post: {
          ...props.post,
          user: user,
        },
        commentList: props.commentList,
      });
    });

    if (state.post.category.code === "talent") {
      fetchOpenings(state.post.id).then((res) => {
        if (res && res[0] && res[0].status === "closed") {
          props.showAppMessage("该职位的招聘已关闭");
        }
        setOpening(res[0]);
      });
    }

    if (
      state.post.category.code === "talent" &&
      state.post.hide &&
      router.pathname.includes("tposts")
    ) {
      props.showAppModal("TalentJobCreatedModal");
    }
  };
  const handlePinPost = () => {
    props.createPostPin(
      props.token,
      state.post.id,
      { pinned: true, pinned_in_category: false, pinned_in_city: false },
      () => {
        setState({
          post: {
            ...state.post,
            pinned: true,
            pinned_in_category: false,
            pinned_in_city: false,
          },
        });
      }
    );
  };
  const handleUnpinPost = () => {
    props.deletePostPin(props.token, state.post.id, () => {
      setState({
        post: {
          ...state.post,
          pinned: false,
          pinned_in_category: false,
          pinned_in_city: false,
        },
      });
    });
  };
  const handlePinPostInCategory = () => {
    props.createPostPin(
      props.token,
      state.post.id,
      { pinned: false, pinned_in_category: true, pinned_in_city: false },
      () => {
        setState({
          post: {
            ...state.post,
            pinned: false,
            pinned_in_category: true,
            pinned_in_city: false,
          },
        });
      }
    );
  };

  const handlePinPostInCity = () => {
    props.createPostPin(
      props.token,
      state.post.id,
      { pinned: false, pinned_in_category: false, pinned_in_city: true },
      () => {
        setState({
          post: {
            ...state.post,
            pinned: false,
            pinned_in_category: false,
            pinned_in_city: true,
          },
        });
      }
    );
  };

  const handleFeaturePost = () => {
    props.createPostFeature(props.token, state.post.id, () => {
      setState({
        post: {
          ...state.post,
          featured: true,
        },
      });
    });
  };
  const handleUnFeaturePost = () => {
    props.deletePostFeature(props.token, state.post.id, () => {
      setState({
        post: {
          ...state.post,
          featured: false,
        },
      });
    });
  };

  // views
  const pageSider = (
    <div>
      <CategoryCard
        category={state.post.category}
        onFollowed={() => {
          props.checkPostFlags(
            props.token,
            ["marked", "upvoted", "downvoted", "limited"],
            [props.post.id]
          );
          props.getUserInfo(props.token);
          fetchPost(props.token, state.post.id, { view: 1 }).then((res) => {
            setState({
              ...state,
              post: res,
            });
          });
        }}
        unFollowed={() =>
          props.checkPostFlags(
            props.token,
            ["marked", "upvoted", "downvoted", "limited"],
            [props.post.id]
          )
        }
      />
      {state.post.group && <RelatedGroupsCard groups={[state.post.group]} />}
      <TalentPostList />
      <RelatedPostList suggests={props.suggests} />
      <WechatGroupCard />
    </div>
  );

  const editButton = (
    <Link
      legacyBehavior
      href={`/${isJob() ? "jobs" : "posts"}/[id]/edit`}
      as={`/${isJob() ? "jobs" : "posts"}/${state.post.id}/edit`}
    >
      <Button
        type="link"
        icon={<FormOutlined />}
        className="px-5 py-0 height-auto"
      >
        编辑
      </Button>
    </Link>
  );
  const editMenuItem = <Menu.Item>{editButton}</Menu.Item>;

  const pinMenuItem = (
    <Menu.Item>
      <Button
        type="link"
        className="px-0 py-0 height-auto"
        onClick={handlePinPost}
      >
        <PushpinOutlined />
        全站置顶
      </Button>
    </Menu.Item>
  );

  const unpinMenuItem = (
    <Menu.Item>
      <Button
        type="link"
        onClick={handleUnpinPost}
        className="px-0 py-0 height-auto"
      >
        <PushpinOutlined />
        取消置顶
      </Button>
    </Menu.Item>
  );

  const pinInCategoryMenuItem = (
    <Menu.Item>
      <Button
        type="link"
        onClick={handlePinPostInCategory}
        className="px-0 py-0 height-auto"
      >
        <PushpinOutlined />
        本版置顶
      </Button>
    </Menu.Item>
  );
  const pinInCityMenuItem = (
    <Menu.Item>
      <Button
        type="link"
        onClick={handlePinPostInCity}
        className="px-0 py-0 height-auto"
      >
        <HomeOutlined />
        城市内置顶
      </Button>
    </Menu.Item>
  );

  const deleteButton = (paddingX) => (
    <Popconfirm
      title="确认删除帖子？"
      placement="bottomRight"
      okText="删除"
      cancelText="取消"
      onConfirm={handleDelete}
    >
      <Button
        type="link"
        icon={<DeleteOutlined />}
        className={`px-${paddingX} py-0 height-auto`}
      >
        删除
      </Button>
    </Popconfirm>
  );

  const delMenuItem = <Menu.Item>{deleteButton(0)}</Menu.Item>;

  const showDeleteConfirmModal = () => {
    let reason = null;
    let templateId = null;
    Modal.confirm({
      title: "确认删除帖子并扣除电量和经验？",
      width: 560,
      content: (
        <Provider store={store}>
          <WordingTemplateAutoComplete
            style={{ width: "100%" }}
            scenario="delete_post"
            onChange={(value) => {
              reason = value;
            }}
            onSelectTemplate={(option) => {
              templateId = option.id;
            }}
            placeholder="删贴原因（选填）"
          />
        </Provider>
      ),
      onOk() {
        handlePenaltyDelete(reason, templateId);
      },
    });
  };
  const showHideConfirmModal = () => {
    let reason = null;
    let templateId = null;
    Modal.confirm({
      title: state.post.hide ? "确认取消隐藏帖子？" : "确认隐藏帖子？",
      width: 560,
      content: isAdmin && !state.post.hide && (
        <Provider store={store}>
          <WordingTemplateAutoComplete
            style={{ width: "100%" }}
            scenario="hide_post"
            onChange={(value) => {
              reason = value;
            }}
            onSelectTemplate={(option) => {
              templateId = option.id;
            }}
            placeholder="隐藏原因（选填）"
          />
        </Provider>
      ),
      onOk() {
        handleHide(!state.post.hide, reason, templateId);
      },
    });
  };
  const penalDeleteButton = (paddingX) => (
    <Button
      type="link"
      icon={<DeleteOutlined />}
      className={`px-${paddingX} py-0 height-auto`}
      onClick={showDeleteConfirmModal}
    >
      管理删除
    </Button>
  );

  const penaltyDelMenuItem = <Menu.Item>{penalDeleteButton(0)}</Menu.Item>;
  const adminHideMenuItem = (
    <Menu.Item>
      <Button
        type="link"
        icon={<DeleteOutlined />}
        className="px-0 py-0 height-auto"
        onClick={showHideConfirmModal}
      >
        管理隐藏
      </Button>
    </Menu.Item>
  );
  const adminUnHideMenuItem = (
    <Menu.Item>
      <Button
        type="link"
        icon={<DeleteOutlined />}
        className="px-0 py-0 height-auto"
        onClick={showHideConfirmModal}
      >
        取消管理隐藏
      </Button>
    </Menu.Item>
  );
  const hideMenuItem = (
    <Menu.Item>
      <Button
        type="link"
        icon={<DeleteOutlined />}
        className="px-0 py-0 height-auto"
        onClick={showHideConfirmModal}
      >
        隐藏
      </Button>
    </Menu.Item>
  );
  const unhideMenuItem = (
    <Menu.Item>
      <Button
        type="link"
        icon={<DeleteOutlined />}
        className="px-0 py-0 height-auto"
        onClick={showHideConfirmModal}
      >
        取消隐藏
      </Button>
    </Menu.Item>
  );

  const featureMenuItem = (
    <Menu.Item>
      <Button
        type="link"
        className="px-0 py-0 height-auto"
        onClick={handleFeaturePost}
      >
        <HighlightOutlined />
        加精
      </Button>
    </Menu.Item>
  );
  const unfeatureMenuItem = (
    <Menu.Item>
      <Button
        type="link"
        onClick={handleUnFeaturePost}
        className="px-0 py-0 height-auto"
      >
        <HighlightOutlined />
        取消加精
      </Button>
    </Menu.Item>
  );
  const editVisibility = (
    <Menu.Item>
      <Button
        type="link"
        onClick={() => setIsOpen(true)}
        className="px-0 py-0 height-auto"
      >
        {/* {state.post.visibility === "public" ? (
          <>
            <GlobalOutlined className="mr-8" />
            公开
          </>
        ) : state.post.visibility === "private" ? (
          <>
            <LockOutlined className="mr-8" />
            私密
          </>
        ) : state.post.visibility === "internal" ? (
          <>
            <FilterOutlined className="mr-8" />
            内部可见
          </>
        ) : (
          <>
            <FrownOutlined className="mr-8" />
            隐藏
          </>
        )} */}
        <EyeOutlined />
        可见性设置
      </Button>
    </Menu.Item>
  );

  const applyforPinning = (
    <Menu.Item>
      <Badge count={<BadgeText>顶</BadgeText>}>
        <Button
          type="link"
          onClick={() =>
            window.open("https://eleduck.com/posts/ZXf5nz", "_blank")
          }
          className="px-0 py-0 height-auto"
        >
          <RiseOutlined />
          申请置顶
        </Button>
      </Badge>
    </Menu.Item>
  );

  const canEditVisibility =
    isAdmin ||
    (isOwner &&
      state.post.visibility !== "hidden" &&
      state.post.visibility !== "prohibited_word_review" &&
      state.post.category.code !== "talent");

  const visibilityIcons = {
    public: <GlobalOutlined />,
    private: <LockOutlined />,
    internal: <FilterOutlined />,
    hidden: <FrownOutlined />,
  };

  const visibilityButtonNames = {
    public: "公开",
    private: "私密",
    internal: "内部可见",
    hidden: "隐藏",
  };

  const editMenu = (
    <Menu>
      {isAdmin &&
        (state.post.pinned ||
          state.post.pinned_in_category ||
          state.post.pinned_in_city) &&
        unpinMenuItem}
      {isAdmin &&
        !state.post.pinned &&
        !state.post.pinned_in_category &&
        !state.post.pinned_in_city &&
        pinMenuItem}
      {isAdmin &&
        !state.post.pinned &&
        !state.post.pinned_in_category &&
        !state.post.pinned_in_city &&
        pinInCategoryMenuItem}
      {isAdmin &&
        !state.post.pinned &&
        !state.post.pinned_in_category &&
        !state.post.pinned_in_city &&
        pinInCityMenuItem}
      {isAdmin && !state.post.featured && featureMenuItem}
      {isAdmin && state.post.featured && unfeatureMenuItem}
      {isMobile && (
        <>
          {/* {canEdit && editMenuItem} */}
          {(isOwner || isAdmin) && delMenuItem}
          {isAdmin && penaltyDelMenuItem}
        </>
      )}
      {isMobile && isOwner && applyforPinning}
      {isMobile && canEditVisibility && editVisibility}
    </Menu>
  );
  const editDropDown = (
    <Dropdown
      overlay={editMenu}
      placement="bottomRight"
      trigger={["click"]}
    >
      <Button
        type="link"
        icon={<SettingOutlined />}
        className="px-5"
      >
        <DownOutlined />
      </Button>
    </Dropdown>
  );
  const pinnedMark = (
    <Tooltip title="已全站置顶">
      <PushpinFilled className="ml-10 text-sm text-primary text-bottom" />
    </Tooltip>
  );
  const pinnedInCategoryMark = (
    <Tooltip title="已本版置顶">
      <PushpinOutlined className="ml-10 text-sm text-primary text-bottom" />
    </Tooltip>
  );
  const pinnedInCityMark = (
    <Tooltip title="已在本城市内部置顶">
      <HomeOutlined className="ml-10 text-sm text-primary text-bottom" />
    </Tooltip>
  );
  const featuredMark = (
    <Tooltip title="已加精">
      {/* <FeaturedIcon className="ml-10 text-middle" /> */}
      <span className="ml-10 text-middle">
        <Image src={FeaturedIcon}></Image>
      </span>
    </Tooltip>
  );

  const buildUrl = (tag) => {
    const ids = state.post.category.tag_groups.map((group) =>
      group.id === tag.tag_group.id ? tag.id : 0
    );

    return `/categories/${state.post.category.id}?tags=${ids.join("-")}`;
  };

  const renderTagGroups = () => {
    return state.post.category.tag_groups.map((group) => {
      const tags = _.filter(
        state.post.tags,
        (tag) => tag.tag_group.id === group.id
      );
      if (tags.length === 0) return;

      return (
        <FieldItem
          key={group.id}
          label={group.name}
        >
          {tags.map((tag) => (
            <TagLink
              key={tag.id}
              href={buildUrl(tag)}
            >
              {tag.name}
            </TagLink>
          ))}
        </FieldItem>
      );
    });
  };
  const renderContactAddon = () => {
    let result = (
      <PostContactAddon
        post={state.post}
        isOwner={isOwner}
        buttonText={"申请该职位"}
        ele={5}
      />
    );
    if (state.post.category.code === "writing") {
      result = (
        <PostContactAddon
          post={state.post}
          isOwner={isOwner}
          buttonText={"申请投稿"}
          ele={1}
        />
      );
    }
    return result;
  };

  const renderPostStatusToggleAddon = () => {
    return (
      <PostStatusToggleAddon
        post={state.post}
        isOwner={isOwner}
      />
    );
  };

  const renderTalentAddon = () => {
    return (
      state.post.category.code === "talent" && (
        <PostTalentAddon
          opening={opening}
          post={state.post}
        />
      )
    );
  };

  const renderActionButtons = () => {
    return (
      <div className="flex justify-content-center">
        <PostVoteAction
          post={state.post}
          upvoted={
            props.flags.upvoted && props.flags.upvoted.includes(props.post.id)
          }
          downvoted={
            props.flags.downvoted &&
            props.flags.downvoted.includes(props.post.id)
          }
          contentType="Post"
        />
        <PostMarkAction
          postId={state.post.id}
          marked={props.flags.marked}
        />
        <SiteReportAction
          contentType={"Post"}
          contentId={state.post.id}
        />
      </div>
    );
  };

  const handleChangeSort = (sort, sortKey, isDesc) => {
    setState({
      ...state,
      sort,
      sortKey,
      isDesc,
    });
  };

  const handleVisibility = () => {
    props.setVisibility(
      props.token,
      state.post.id,
      visibility,
      hideReason,
      hideTemplateId,
      (visibility, hidedAt, visibilitySetter) => {
        setState({
          post: {
            ...props.post,
            visibility,
            hided_at: hidedAt,
            visibility_setter: visibilitySetter,
            reason: hideReason,
          },
        });
        setIsOpen(false);
        setHideTemplateId(null);
      }
    );
  };

  useEffect(() => {
    if (!props.token) {
      fetchPostComments(state.post.id, { page: 1, sort: state.sort }).then(
        (res) => {
          setState({
            ...state,
            commentList: res,
          });
        }
      );
    }
  }, [state.sort]);

  // events
  useEffect(() => handleInit(), [props.post?.id]);

  // 用户登录后，读取用户关注的版块，用于确认发帖权限
  useEffect(() => {
    props.user && props.getFollowedCategories(props.user.id);
  }, [props.user]);

  // 用户登录后，获取共学共创信息
  useEffect(() => {
    props.fetchCollaboration(props.token, state.post.category.id);
  }, [props.token]);

  if (
    (state.post.category.code !== "talent" &&
      router.pathname.includes("tposts")) ||
    (state.post.category.code === "talent" && router.pathname === "/posts/[id]")
  ) {
    return <Error statusCode={404} />;
  }

  const hidedMessage = (post) => {
    const revertBtn = (
      <a
        onClick={() => {
          props.setApplication({
            targetType: "Post",
            targetId: post.id,
            kind: "post_recovery",
          });
          props.showAppModal("ApplicationModal");
        }}
      >
        →申请恢复
      </a>
    );

    let m = (
      <span>
        【该文于 {timeAgo(post.hided_at)}被
        {props.post.user.id !== post.visibility_setter.id
          ? " " + post.visibility_setter.nickname + " 用户"
          : "系统"}
        隐藏
        {post.reason ? `，隐藏原因：${post.reason}】` : "】"}
        {revertBtn}
      </span>
    );

    if (post.category.code === "talent") {
      m = `当前为隐藏状态，待管理员审核通过后（24小时内），会正式发布到人才库，开始推荐。${
        post.reason ? `隐藏原因：${post.reason}` : ""
      }`;
    }
    if (post.visibility === "prohibited_word_review") {
      m = (
        <span>
          【该文于 {timeAgo(post.hided_at)}被系统隐藏
          {post.reason ? `，隐藏原因：${post.reason}】` : "】"}
          {revertBtn}
        </span>
      );
    }
    return m;
  };
  return (
    <SiteLayout
      pageTitle={state.post.title}
      pageSider={pageSider}
      keywords={state.post.title}
      description={stripHtml(state.post.content).slice(0, 200)}
      isPost
    >
      {isMobile && <AppMobileNav />}
      <BaseModal
        isOpen={isOpen}
        hideModal={() => setIsOpen(false)}
      >
        <Menu
          mode="horizontal"
          selectedKeys={["mute"]}
        >
          <Menu.Item key="mute">可见性设置</Menu.Item>
        </Menu>
        <Form
          layout="vertical"
          onFinish={handleVisibility}
        >
          <Form.Item>
            <Radio.Group
              onChange={(e) => {
                setVisibility(e.target.value);
              }}
              defaultValue={visibility}
            >
              <Space
                direction="vertical"
                className="my-10"
              >
                <Radio
                  value="public"
                  checked={visibility === "public"}
                >
                  公开（所有人可见）
                </Radio>
                {isOwner && (
                  <Radio
                    value="private"
                    checked={visibility === "private"}
                  >
                    私密（仅自己可见）
                  </Radio>
                )}
                {isAdmin && isOwner && (
                  <Radio
                    value="internal"
                    checked={visibility === "internal"}
                  >
                    内部可见（所有人可见，不显示在首页等公开列表中）
                  </Radio>
                )}
                {isAdmin && (
                  <Radio
                    value="hidden"
                    checked={visibility === "hidden"}
                  >
                    隐藏
                  </Radio>
                )}
              </Space>
            </Radio.Group>
          </Form.Item>
          {isAdmin && visibility === "hidden" && (
            <Form.Item>
              <WordingTemplateAutoComplete
                scenario="hide_post"
                onChange={(value) => {
                  setHideReason(value);
                }}
                onSelectTemplate={(option) => {
                  setHideTemplateId(option.id);
                }}
                placeholder="隐藏原因（选填）"
              />
            </Form.Item>
          )}
          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              block
            >
              确定
            </Button>
          </Form.Item>
        </Form>
      </BaseModal>
      {(state.post.visibility === "hidden" ||
        state.post.visibility === "prohibited_word_review") && (
        <Alert
          style={{ marginBottom: "10px" }}
          type="warning"
          message={hidedMessage(state.post)}
        />
      )}
      {state.post.visibility === "private" && (
        <Alert
          style={{ marginBottom: "10px" }}
          type="warning"
          message="此贴为私密帖子，仅自己可见"
        />
      )}
      {state.post.visibility === "internal" && isOwner && (
        <Alert
          style={{ marginBottom: "10px" }}
          type="warning"
          message="此贴为内部可见帖子，所有人可见，但不显示在社区首页或版块等公开的列表中"
        />
      )}
      <Card style={STYLE_MB2}>
        <h1 className="page-title">
          <CategoryLink
            category={state.post.category}
            className="mr-5"
          />
          {state.post.full_title}
          {state.post.featured && featuredMark}
          {state.post.pinned && pinnedMark}
          {state.post.pinned_in_category && pinnedInCategoryMark}
          {state.post.pinned_in_city && pinnedInCityMark}
        </h1>

        <div className="meta-info mb-15">
          <span>
            {state.post.contributors.length === 0 && (
              <UserAvatar
                user={state.post.user}
                size={24}
                className="mr-5"
              />
            )}

            <UserLink user={state.post.user} />
          </span>

          {state.post.contributors.length > 0 && (
            <span>
              <UserLink user={state.post.contributors[0]} />
            </span>
          )}

          {state.post.contributors.length > 0 && (
            <span>共{state.post.contributors.length + 1}人</span>
          )}

          <span>{state.post.views_count}阅读</span>
          <span>{state.post.comments_count}评论</span>
          <span>
            <TimeAgoTag time={state.post.published_at} />
          </span>
        </div>

        <div className="post-contents mb-15">
          <RichContent html={state.post.content} />
          {isModified && (
            <p>
              <LastModifiedTag time={state.post.modified_at} />
            </p>
          )}
          {canViewPost && renderTagGroups()}
          {!canViewPost && (
            <div style={{ position: "relative" }}>
              <div
                style={{
                  position: "absolute",
                  bottom: 0,
                  left: 0,
                  width: "100%",
                  height: "150px",
                  background:
                    "linear-gradient(to top, rgba(255, 255, 255, 1) 0%,rgba(255, 255, 255, 1) 40%,rgba(255, 255, 255, 0.75) 60%,rgba(255, 255, 255, 0.5) 80%,rgba(255, 255, 255, 0) 100%)",
                  pointerEvents: "none",
                }}
              >
                <div className="text-center mt-100 font-14 text-secondary">
                  关注并加入即可观看全文
                </div>
              </div>
            </div>
          )}
        </div>
        <div className="post-addons-container">
          {supportContactAddon() && renderContactAddon()}
          {isOwner &&
            state.post.category.code === "jd" &&
            renderPostStatusToggleAddon()}
        </div>
        {renderTalentAddon()}
        {canViewPost && renderActionButtons()}

        <PostCategoryHint category={state.post.category} />

        <div className="text-right">
          {props.token && showCommentForm && (
            <Button
              type="link"
              icon={<MessageOutlined />}
              className="px-5"
            >
              <a
                href="#foot-coment-form"
                className="text-primary"
              >
                <span style={{ marginLeft: "8px" }}>评论</span>
              </a>
            </Button>
          )}
          {canEdit && editButton}
          {!isMobile && (
            <>
              {(isOwner || isAdmin) && deleteButton(5)}
              {isAdmin && penalDeleteButton(5)}
            </>
          )}
          {canViewPost && (
            <SharePopover url={appUrl + postUrl(state.post)}>
              <Button
                type="link"
                icon={<ShareAltOutlined />}
                className="px-5"
              >
                分享
              </Button>
            </SharePopover>
          )}
          {!isMobile && isOwner && (
            <Badge count={<BadgeText>顶</BadgeText>}>
              <Button
                type="link"
                onClick={() =>
                  window.open("https://eleduck.com/posts/ZXf5nz", "_blank")
                }
                className="px-5 py-0 height-auto"
              >
                <RiseOutlined />
                申请置顶
              </Button>
            </Badge>
          )}
          {!isMobile && canEditVisibility && (
            <Button
              type="link"
              // icon={visibilityIcons[state.post.visibility]}
              icon={<EyeOutlined />}
              onClick={() => setIsOpen(true)}
              className="px-5 py-0 height-auto"
            >
              {/* {visibilityButtonNames[state.post.visibility]} */}
              可见性设置
            </Button>
          )}
          {props.token && (isAdmin || isMobile) && editDropDown}
        </div>
      </Card>

      <PostPromos promos={props.promos}></PostPromos>

      <Card style={STYLE_MB2}>
        {state.post.contributors.length === 0 ? (
          <div className="user-info-and-charges">
            <UserInfoBlock
              showCreateTime
              user={state.post.user}
              showLevel
            />
            <PostChargeBlock post={state.post} />
          </div>
        ) : (
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              flexWrap: "wrap",
              justifyContent: "flex-start",
              alignItems: "center",
            }}
          >
            {_.concat(state.post.user, state.post.contributors).map(
              (contributor) => (
                <UserInfoBlock
                  key={contributor.id}
                  small={true}
                  style={{ width: "50%" }}
                  user={contributor}
                  showLevel
                />
              )
            )}
          </div>
        )}
      </Card>

      {state.post.contributors.length !== 0 && (
        <Card className="text-center py-20">
          <PostChargeBlock
            post={state.post}
            showCount={10}
          />
        </Card>
      )}

      {showCommentForm && (
        <Card id="foot-coment-form">
          <CommentForm
            postId={state.post.id}
            title={state.post.full_title || state.post.title}
          />
        </Card>
      )}

      <Card
        title="精选评论"
        extra={
          <CommentSortMenu
            sort={state.sort}
            sortKey={state.sortKey}
            isDesc={state.isDesc}
            callback={handleChangeSort}
          />
        }
      >
        <CommentList
          commentSsr={state.commentList}
          post={state.post}
          sort={state.sort}
        />
      </Card>
    </SiteLayout>
  );
};

const mapStateToProps = (state) => ({
  user: state.user.user,
  token: state.user.token,
  flags: state.post.flags,
  postChargeList: state.post.postChargeList,
  postChargesCount: state.post.postChargesCount,
  postChargesEle: state.post.postChargesEle,
  postCharged: state.post.postCharged,
  promos: state.app.promos,
  collaboration: state.app.collaboration,
  followedCategories: state.app.followedCategories,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      checkPostFlags,
      getUserInfo,
      deletePost,
      hidePost,
      createPostPin,
      deletePostPin,
      getPromos,
      showAppModal,
      createPostFeature,
      deletePostFeature,
      setVisibility,
      setApplication,
      showAppMessage,
      fetchCollaboration,
      getFollowedCategories,
      getPrefs,
    },
    dispatch
  );

Page.requireUser = () => false;

Page.getInitialProps = async (ctx) => {
  const { id } = ctx.query;
  const state = ctx.store.getState();
  let post,
    commentList,
    suggests,
    talentPosts,
    categories = {};
  let responseError = {};
  try {
    post = await fetchPost(state.user.token, id, { view: 1 });
    if (!post.deleted) {
      commentList = await fetchPostComments(id, { page: 1, sort: "-hot" });
      suggests = await fetchPostSuggests({ category: post.category.id });
      talentPosts = await fetchRandomTalentPosts();
      if (!state.app.categories.length) {
        await ctx.store.dispatch(getCategories());
      }
      categories = state.app.categories;
    }
  } catch (error) {
    responseError.message = error.message;
    responseError.code = error.error;
    responseError.statusCode = error.statusCode;
    ctx.res.statusCode = error.statusCode;
  }
  return {
    post,
    commentList,
    suggests,
    talentPosts,
    categories,
    responseError,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Page);
